import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Container, Row, Card, CardBody, Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import { MDBDataTable } from "mdbreact";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import MetaTagComp from "../../../components/Common/MetaTags";
import { CSVLink } from "react-csv";
// import ViewModal from "./components/ViewModal";
import Loading from "components/Loading";
import { useStore1Selector } from "../../../index";
import { loginUser } from "../../../Redux/Slices/userSlice";
import LicenseForm from "./components/LicenseForm";
// import TenantDetails from "./components/TenantDetails";
// import { warningMessage, successMessage } from "../../components/Notifications";
// import Empty from "components/Empty";
// import Cards from "./components/Cards";

import useFetch from "../../../hooks/useFecth";
import usePost from "../../../hooks/usePost";
import { refresh } from "aos";

function CreateLicense() {
  const userDet = useStore1Selector(loginUser);
  const { execute, pending } = usePost();
  const token = userDet?.token;

  const { data: getUsers, reFetch: reFetchGetUsers } = useFetch(
    `https://gh.prop.faspro24.com/api/v1/users/admin?license=false`,
    userDet?.token
  );

  const [userID, setUserID] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [sendLicenseModal, setSendLicenseModal] = useState(false);
  let list = [];

  getUsers?.forEach((res) => {
    list.push({
      ...res,
      role:
        res?.roles[0] === "property_owner_individual"
          ? "Individual"
          : "Company",
      suspendBtn: (
        <button
          className="btn btn-primary"
          onClick={() => sendLicenseFunc(res?._id)}
        >
          Send license
        </button>
      ),
      deleteBtn: (
        <button className="btn btn-danger" onClick={() => deleteFunc(res?._id)}>
          Delete
        </button>
      ),
    });
  });

  function sendLicenseFunc(id) {
    setUserID(id);
    setSendLicenseModal(true);
  }

  function deleteFunc(id) {
    setUserID(id);
    setDeleteModal(true);
  }
  const deleteUserFunc = () => {
    const Method = "DELETE",
      endPoint = `users/${userID}`;
    const raw = "";
    execute(endPoint, raw, Method, "User Successfully Deleted", token);
    setDeleteModal(false);
  };

  if (pending) {
    setTimeout(() => {
      reFetchGetUsers();
    }, 2000);
  }

  const column = [
    { label: "First Name", field: "firstName", sort: "asc", width: 150 },
    { label: "Last Name", field: "lastName", sort: "asc", width: 150 },
    { label: "Email", field: "email", sort: "asc", width: 150 },
    { label: "Role", field: "role", sort: "asc", width: 150 },
    { label: "Action", field: "suspendBtn", sort: "asc", width: 150 },
    { label: "Delete", field: "deleteBtn", sort: "asc", width: 150 },
  ];

  const tbdata = {
    columns: column,
    rows: list,
  };
  // console.log("userID...", userID);
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTagComp meta_tags="FASPRO24 | Team" />
        <Breadcrumb default="Provision" title="Create license" />
        <CardBody>
          <Container fluid>
            <Row className="d-flex justify-content-around align-items-center">
              <CardBody data-aos="fade-bottom">
                <Card className="bd-rds">
                  <CardBody>
                    <MDBDataTable
                      entries={5}
                      entriesOptions={[5, 10, 50]}
                      responsive
                      bordered
                      striped
                      hover
                      data={tbdata}
                    />
                  </CardBody>
                </Card>
              </CardBody>
            </Row>
          </Container>
        </CardBody>
      </div>

      <Modal
        show={sendLicenseModal}
        onHide={() => setSendLicenseModal(false)}
        size="lg"
      >
        <Modal.Body className="text-dark">
          <Modal.Header closeButton>
            <Modal.Title>Send License</Modal.Title>
          </Modal.Header>
          <LicenseForm user_ID={userID} closeModal={setSendLicenseModal} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="bg-danger text-white"
            onClick={() => setSendLicenseModal(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={deleteModal} onHide={() => setDeleteModal(false)} size="sm">
        <Modal.Body className="text-danger">
          <h6> Are you sure you want to delete this user ? </h6>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="bg-danger text-white"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="bg-success text-white w-50"
            onClick={deleteUserFunc}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

CreateLicense.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(CreateLicense));
